import { render, staticRenderFns } from "./TopicFeedbackTable.vue?vue&type=template&id=744bf6ae&scoped=true&"
import script from "./TopicFeedbackTable.vue?vue&type=script&lang=js&"
export * from "./TopicFeedbackTable.vue?vue&type=script&lang=js&"
import style0 from "./TopicFeedbackTable.vue?vue&type=style&index=0&id=744bf6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744bf6ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRating } from 'vuetify/lib/components/VRating';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VImg,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VRating,VTooltip})
